import type { GetCompanyTreeResponse, CompanyTreeItemDTO } from '../apis/company-tree-api';
import type { GetCompanyNameResponse, CompanyAutocompleteItemDTO } from '../apis/company-name-api';

export const CompanyService = Symbol.for('CompanyService');

/**
 * 公司服务接口 - 简化版，直接返回API数据
 */
export interface CompanyService {
    /**
     * 获取公司树结构
     * @param query 查询关键词
     * @param exactMatch 是否精确匹配
     */
    getCompanyTree(query: string, exactMatch?: boolean): Promise<GetCompanyTreeResponse>;

    /**
     * 根据名称搜索公司
     * @param query 查询关键词
     * @param fuzzyMatch 是否模糊匹配
     * @param limit 返回数量限制
     */
    searchCompaniesByName(query: string, fuzzyMatch?: boolean, limit?: number): Promise<GetCompanyNameResponse>;
}
